export class User {
  Name: string;
  UserName: string;
  Department: string;
  Faculty: string;
  Roles: string[];
  Token: string;
}



// WEBPACK FOOTER //
// ./src/app/classes/user.ts